import { useEffect, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import { FDWAntragsteller, FDWResultEntry } from "restfd2";
import Checkbox from "./checkbox.tsx";
import LoadingIndicator from "./loading-indicator.tsx";
import Input from "./input.tsx";
import { DoiForm, LeadForm } from "./lead_form.tsx";
import { QuestionizerTabPanel } from "./questionizer-result-tab-panel.tsx";
import { Tab } from "./questionizer-result-tab.tsx";

  export function QuestionizerResultTabs(){
	const include_all_results_in_print = useQuestionizerStore((state) => state.config?.include_all_results_in_print || false);
	const include_in_print = useQuestionizerStore((state) => state.include_in_print);
    const setIncludeInPrint = useQuestionizerStore((state) => state.setIncludeInPrint);
    const [active_tab, set_active_tab] = useState<"zuschusse" | "darlehen">("zuschusse");
    const result = useQuestionizerStore((state) => state.result);
    const initialSelectAll =  include_all_results_in_print || false;
    const [select_all, setSelectAll] = useState(initialSelectAll);
    const L = useQuestionizerStore((state) => state.L);

    type SortedResultsList = Record<string,{region: string, list: Array<FDWResultEntry>}>;

    if (result == undefined){
      return <div></div>
    }
  
    const zuschuesse = result.filter((entry) => entry.fp_type == "Zuschuss").reduce((acc: SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

    const darlehen = result.filter((entry) => entry.fp_type == "Darlehen").reduce((acc : SortedResultsList, entry : FDWResultEntry)=>{
      if (!acc[entry.region]){
        acc[entry.region] = {region:entry.region, list: [entry]}; 
      }else{
        acc[entry.region].list.push(entry);
      }
      return acc;
    },{});

    let zuschuesse_length = Object.keys(zuschuesse).flatMap(key => zuschuesse[key].list).length;
    let darlehen_length = Object.keys(darlehen).flatMap(key => darlehen[key].list).length;

    return (<div className="tabs">
          <div className="tabs__header" role="tablist">
            <Tab label={L('Zuschüsse') || 'Zuschüsse'} value="zuschusse" count={zuschuesse_length} active_tab={active_tab} set_active_tab={set_active_tab}/>
            <Tab label={L('Darlehen') || 'Darlehen'} value="darlehen" count={darlehen_length} active_tab={active_tab} set_active_tab={set_active_tab}/>
          </div>
		
		  <div className="flex flex-row"> 
			  <Checkbox labelledby="alle-auswaehlen" value={select_all}  onChange={(value)=>{
				  setSelectAll(value);
				 Object.keys(include_in_print).forEach((key) => {
					 setIncludeInPrint(Number(key), value);
					});
			  }}/>
			  <p id="alle-auswaehlen" className="mt-[0.5rem]">{L('alle auswählen') || 'alle auswählen'}</p>
		  </div>
          <div className="tabs__body">
            <QuestionizerTabPanel id={"zuschusse"} active={active_tab == "zuschusse"}  regions={zuschuesse} />
            <QuestionizerTabPanel id={"darlehen"} active={active_tab == "darlehen"} regions={darlehen} />
          </div>
    </div>);  
  }